import { Fill, Stroke, Style } from 'ol/style';
import { LIGHT_GREY, GREEN_SHADE_42, GREEN_SHADE_60 } from '@/primary/Color';

export const lightGrey = new Style({
  fill: new Fill({ color: LIGHT_GREY }),
  stroke: new Stroke({ color: [255, 255, 255, 1], width: 0.5 }),
});

export const greenShade42 = new Style({
  fill: new Fill({ color: GREEN_SHADE_42 }),
  stroke: new Stroke({ color: [255, 255, 255, 1], width: 0.5 }),
});

export const greenShade60 = new Style({
  fill: new Fill({ color: GREEN_SHADE_60 }),
  stroke: new Stroke({ color: [255, 255, 255, 1], width: 0.5 }),
});

export const thickStroke = new Style({
  fill: new Fill({ color: [255, 255, 255, 0] }),
  stroke: new Stroke({ color: [99, 103, 113, 1], width: 3 }),
});
